import React, { useState } from "react";
import calculator from "../Images/calculator.svg";

function Section4() {
  const [monthlyConsumption, setMonthlyConsumption] = useState(0);

  const calculateValues = () => {
    const monthlyElectricityBill = monthlyConsumption * 44.7;
    const solarSystemCapacity = monthlyConsumption / 100;
    const monthlyAverageGeneration = solarSystemCapacity * 114;
    const electricityBillSaving = monthlyElectricityBill * 0.06;
    const requiredRoofArea = solarSystemCapacity * 11;

    return {
      monthlyElectricityBill: monthlyElectricityBill.toFixed(2),
      solarSystemCapacity: solarSystemCapacity.toFixed(2),
      monthlyAverageGeneration: monthlyAverageGeneration.toFixed(2),
      electricityBillSaving: electricityBillSaving.toFixed(2),
      requiredRoofArea: requiredRoofArea.toFixed(2),
    };
  };

  const handleInputChange = (e) => {
    setMonthlyConsumption(parseFloat(e.target.value));
  };

  const {
    monthlyElectricityBill,
    solarSystemCapacity,
    monthlyAverageGeneration,
    electricityBillSaving,
    requiredRoofArea,
  } = calculateValues();

  return (
    <div className="flex justify-center items-center px-16 py-20 max-md:px-5">
      <div className="w-full max-w-[1156px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow py-9 w-full rounded-3xl bg-cyan-700 bg-opacity-10 max-md:mt-10 max-md:max-w-full">
              <div className="flex flex-col px-8 font-bold max-md:px-5 max-md:max-w-full">
                <div className="text-3xl text-cyan-700 text-center leading-[52.08px] max-md:max-w-full">
                  Bill Calculator
                </div>
                <div className="mt-1 text-xl font-semibold leading-6 text-center text-zinc-800 max-md:max-w-full">
                  Looking for great reasons to go solar?
                </div>
                <div className="mt-2 text-base leading-6 text-zinc-500 max-md:max-w-full">
                  Simply enter how much you spend each month on your electricity
                  bill, and we will let you know how we can help bring that
                  number to zero with our solar power solutions.
                </div>
                <div className="self-center mt-4 text-xl leading-6 text-center text-neutral-800">
                  kWh
                </div>
              </div>
              <input
                type="number"
                placeholder="Enter Monthly Consumption (kWh)"
                className="justify-center items-center px-16 py-4 mx-8 mt-2 text-lg text-center bg-white rounded-xl border-b-2 border-cyan-700 border-solid text-neutral-500 max-md:px-5 max-md:mr-2.5 max-md:max-w-full"
                onChange={handleInputChange}
                value={monthlyConsumption}
              />
              <div className="flex gap-5 mx-8 mt-6 text-center text-zinc-800 max-md:flex-wrap max-md:mr-2.5">
                <div className="flex flex-col flex-1 px-2 py-2 rounded-2xl bg-slate-700 bg-opacity-40 max-md:px-5">
                  <div className="text-base leading-6">Solar Power</div>
                  <div className="flex gap-1 self-center mt-0 mb-1 whitespace-nowrap">
                    <div className="grow text-2xl leading-6 font-medium">
                      {solarSystemCapacity} kWp
                    </div>
                  </div>
                </div>
                <div className="flex flex-col flex-1 px-6 py-2 rounded-2xl bg-slate-700 bg-opacity-40 max-md:px-5">
                  <div className="text-base leading-6">
                    Monthly Electricity Bill
                  </div>
                  <div className="self-center mt-0 mb-1 text-2xl leading-6 font-medium">
                    Rs.{monthlyElectricityBill}
                  </div>
                </div>
              </div>
              <div className="flex gap-5 mx-8 mt-6 text-center text-zinc-800 max-md:flex-wrap max-md:mr-2.5">
                <div className="flex flex-col flex-1 px-2 py-2 rounded-2xl bg-slate-700 bg-opacity-40 max-md:px-5">
                  <div className="text-base leading-6">Required Roof Area</div>
                  <div className="flex gap-1 self-center mt-0 mb-1 whitespace-nowrap">
                    <div className="grow text-2xl leading-6 font-medium">
                      {requiredRoofArea} Sq m
                    </div>
                  </div>
                </div>
                <div className="flex flex-col flex-1 px-6 py-2 rounded-2xl bg-slate-700 bg-opacity-40 max-md:px-5">
                  <div className="text-base leading-6">
                    Electricity Bill Saving
                  </div>
                  <div className="self-center mt-0 mb-1 text-2xl leading-6 font-medium">
                    Rs.{electricityBillSaving}
                  </div>
                </div>
              </div>
              <div className="flex gap-5 mx-8 mt-6 text-center text-zinc-800 max-md:flex-wrap max-md:mr-2.5">
                <div className="flex flex-col flex-1 px-16 py-2 rounded-2xl bg-slate-700 bg-opacity-40 max-md:px-5">
                  <div className="text-base leading-6">
                    Monthly Average Generation
                  </div>
                  <div className="flex gap-1 self-center mt-0 mb-1 whitespace-nowrap">
                    <div className="grow text-2xl leading-6 font-medium">
                      {monthlyAverageGeneration} kWh
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <img
              loading="lazy"
              src={calculator}
              className="self-stretch my-auto w-full aspect-[1.11] max-md:mt-10 max-md:max-w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section4;
